"use strict";

var _require = require("lodash"),
    invert = _require.invert;

var aminoAcidToDegenerateDnaMap = require("./aminoAcidToDegenerateDnaMap");

var degenerateDnaToAminoAcidMap = invert(aminoAcidToDegenerateDnaMap);
module.exports = degenerateDnaToAminoAcidMap;